import request from '~services/request';
export const MapService = {
    getAll: () => request.get('/map').then(response => response.data.data),
    getOne: id => request.get(`/map/${id}`).then(response => response.data.data)
};
